import DoduThemeIndex from "./doduThemeIndex"
import themeBg from "./assets/theme_bg.png"
import { useLocation } from "react-router-dom"
import { useEffect, useRef } from "react"

const DoduLayout = () => {

    const rootRef = useRef<HTMLDivElement>(null)
    const location = useLocation()
    const isThemePage = location.pathname === "/showcase/theme/dodu"
    const isWatchPage = location.pathname === "/showcase/watch/dodu"

    // ios 좌우 스크롤 시 상하단 이동 방지
    useEffect(() => {
        const root = rootRef.current
        const html = document.documentElement
        const body = document.body
        const previousHtmlOverflow = html.style.overflow
        const previousHtmlOverscrollBehavior = html.style.overscrollBehavior
        const previousBodyOverflow = body.style.overflow
        const previousBodyPosition = body.style.position
        const previousBodyWidth = body.style.width
        const previousBodyHeight = body.style.height
        const previousBodyTouchAction = body.style.touchAction

        html.style.overflow = "hidden"
        html.style.overscrollBehavior = "none"
        body.style.overflow = "hidden"
        body.style.position = "fixed"
        body.style.width = "100%"
        body.style.height = "100%"
        body.style.touchAction = "none"

        let startX = 0
        let startY = 0

        const handleTouchStart = (event: TouchEvent) => {
            const touch = event.touches[0]

            if (!touch) {
                return
            }

            startX = touch.clientX
            startY = touch.clientY
        }

        const handleTouchMove = (event: TouchEvent) => {
            const touch = event.touches[0]

            if (!touch) {
                return
            }

            const deltaX = touch.clientX - startX
            const deltaY = touch.clientY - startY

            if (Math.abs(deltaY) > Math.abs(deltaX)) {
                event.preventDefault()
            }
        }

        root?.addEventListener("touchstart", handleTouchStart, { passive: true })
        root?.addEventListener("touchmove", handleTouchMove, { passive: false })

        return () => {
            root?.removeEventListener("touchstart", handleTouchStart)
            root?.removeEventListener("touchmove", handleTouchMove)
            html.style.overflow = previousHtmlOverflow
            html.style.overscrollBehavior = previousHtmlOverscrollBehavior
            body.style.overflow = previousBodyOverflow
            body.style.position = previousBodyPosition
            body.style.width = previousBodyWidth
            body.style.height = previousBodyHeight
            body.style.touchAction = previousBodyTouchAction
        }
    }, [])

    return (
        <div ref={rootRef} className={`relative h-full overscroll-none ${isWatchPage ? "overflow-visible" : "overflow-hidden"} sm:mx-24 lg:mx-[36rem]`}>
            <div className="absolute inset-0 overflow-hidden">
                <img
                    src={isThemePage ? themeBg : ""}
                    className="object-cover"
                    alt=""
                />
            </div>

            <div className="relative z-10 grid h-full grid-rows-[1fr_2.7fr] sm:grid-rows-[1fr_1.3fr]">
                <div />
                <div className="min-h-0">
                    {
                        isThemePage ? <DoduThemeIndex /> : null
                    }
                </div>
            </div>

            {
                isWatchPage ? (
                    <div className="absolute inset-y-0 left-1/2 z-50 flex w-screen -translate-x-1/2 items-center justify-center bg-black/80">
                        <p className="text-3xl font-bold tracking-wide text-white md:text-5xl">
                            Comming Soon
                        </p>
                    </div>
                ) : null
            }
        </div>
    )
}

export default DoduLayout
